// extracted by mini-css-extract-plugin
export default {"citiesReceptionCentersPages":"cities-reception-centers-page_citiesReceptionCentersPages__H3S0h"};